import api from './api';
import { Preferences } from '@capacitor/preferences';


const services = {
    api,
    preferences: Preferences
}

export default services;